import { gql } from "@apollo/client";

export const CREATE_JOB = gql`
    mutation createJob($street1: String, $street2: String, $city: String, $state: String, $zipcode: String, $name: String!, $customerName: String, $customerContactName: String, $customerPhone: String, $customerEmail: String, $estimatedStartDate: Date, $wageRate: String) {
        createJob(street1: $street1, street2: $street2, city: $city, state: $state, zipcode: $zipcode, name: $name, customerName: $customerName, customerContactName: $customerContactName, customerPhone: $customerPhone, customerEmail: $customerEmail, estimatedStartDate: $estimatedStartDate, wageRate: $wageRate) {
            job {
                id
            }
        }
    }
`

export const EDIT_JOB = gql`
    mutation editJob($id: Int!, $street1: String, $street2: String, $city: String, $state: String, $zipcode: String, $name: String!, $customerName: String, $customerContactName: String, $customerPhone: String, $customerEmail: String, $estimatedStartDate: Date, $wageRate: String, $isActive: Boolean) {
        editJob(id: $id, street1: $street1, street2: $street2, city: $city, state: $state, zipcode: $zipcode, name: $name, customerName: $customerName, customerContactName: $customerContactName, customerPhone: $customerPhone, customerEmail: $customerEmail, estimatedStartDate: $estimatedStartDate, wageRate: $wageRate, isActive: $isActive) {
            job {
                id
            }
        }
    }
`

export const DELETE_JOB = gql`
    mutation deleteJob($id: Int!) {
        deleteJob(id: $id) {
            didDelete
            message
        }
    }
`;
